var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price"},[_c('el-image',{staticClass:"goodImg",attrs:{"src":_vm.img,"fit":"contain"}},[_c('template',{slot:"error"},[_c('img',{staticClass:"goodsImg",staticStyle:{"object-fit":"contain"},attrs:{"src":require("@/assets/img/bitmap.png")}})])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }